import parseResponseSTM from 'core/services/getPlansByProductId/parseResponseSTM'
import { getSTMBTM } from 'core/controllerPlans/getPlans'
import store from 'utils/store/withMiddleware'

function loadSTMBTMPlans() {
  return getSTMBTM(store.getState())
    .then(parseResponseSTM)
    .then(([response]) => {
      delete response.filters

      store.update({ ...response, loading: false })
    })
}

export default loadSTMBTMPlans
